<template>
  <c-q-btn
    id="btn-review-institutional"
    propBtnLabel="Revisar Cadastro"
    :propBtnFunction="onReviewInstitutionalClick"
    :propBtnTransparent="false"
    :propBtnSize="EnumButtonSizes.LARGE_1"
    
  />
</template>

<script setup lang="ts">
import { EnumButtonSizes, EnumRouteNames } from '@/enums/enums';
import { useRouter } from 'vue-router';
import { useInstitutionalStore } from '@/stores/institutionalStore';
import { useRedeSubredeStore } from '@/stores/redeSubredeStore';
import { useQuasar } from 'quasar';
import messages from '@/utils/messages';
import { computed } from 'vue';

const router = useRouter();
const institutionalStore = useInstitutionalStore();
const redeSubredeStore = useRedeSubredeStore();
const $q = useQuasar();

const props = defineProps<{
  accordionRef?: any;
}>();

// const onReviewInstitutionalClick = () => {
//   const imagens = props.accordionRef?.getImagensSemUpload?.() || []

//   const exibeTelaAbertura = props.accordionRef?.getExibeTelaAbertura?.() ?? false
//   const alterarTelaAbertura = props.accordionRef?.getAlterarTelaAbertura?.() ?? 'nao'
//   const telas = props.accordionRef?.getTelasSeleccionadas?.() || []
//   const corTexto = props.accordionRef?.getCorTexto?.() ?? null

//   if (!institutionalStore.validateFocusedInstitutionalFields(imagens, alterarTelaAbertura)) return

//   const data = institutionalStore.institutionalDetail || institutionalStore.institutionalDraft

//   if (data) {
//     data.exibeTelaAbertura = exibeTelaAbertura
//     ;(data as any).alterarTelaAbertura = alterarTelaAbertura
//     ;(data as any).telasCadastradas = telas
//     data.corTexto = corTexto ?? undefined
//   }

//   institutionalStore.setReviewData({
//     ...data,
//     imagens,
//     telasCadastradas: telas,
//     corTexto,
//     exibeTelaAbertura,
//     alterarTelaAbertura
//   })

//   institutionalStore.setImagensDraft(imagens)
//   institutionalStore.setTelasDraft(telas)
//   institutionalStore.setExibeTelaAbertura(exibeTelaAbertura)

//   router.push({
//     name: EnumRouteNames.INSTITUTIONAL_REVIEW,
//     ...(data?.id ? { params: { id: data.id } } : {})
//   })
// }

const onReviewInstitutionalClick = () => {
  const imagens = props.accordionRef?.getImagensSemUpload?.() || []

  const exibeTelaAbertura = props.accordionRef?.getExibeTelaAbertura?.() ?? false
  const alterarTelaAbertura = props.accordionRef?.getAlterarTelaAbertura?.() ?? 'nao'

  if (!institutionalStore.validateFocusedInstitutionalFields(imagens, alterarTelaAbertura)) return

  const telas = props.accordionRef?.getTelasSeleccionadas?.() || []
  const corTexto = props.accordionRef?.getCorTexto?.() ?? null

  const data = institutionalStore.institutionalDetail || institutionalStore.institutionalDraft

  if (data) {
    data.exibeTelaAbertura = exibeTelaAbertura
    ;(data as any).alterarTelaAbertura = alterarTelaAbertura
    data.corTexto = corTexto ?? undefined
  }

  institutionalStore.setReviewData({
    ...data,
    imagens,
    telasCadastradas: telas,
    corTexto,
    exibeTelaAbertura,
    alterarTelaAbertura
  })

  institutionalStore.setImagensDraft(imagens)
  institutionalStore.setTelasDraft(telas)
  institutionalStore.setExibeTelaAbertura(exibeTelaAbertura)

  if ((data as any)?.id) {
    institutionalStore.setVeioDaReview(true)
    router.push({
      name: EnumRouteNames.INSTITUTIONAL_REVIEW,
      params: { id: (data as any).id }
    })
  } else {
    router.push({ name: EnumRouteNames.INSTITUTIONAL_REVIEW })
  }
}

</script>

<style scoped>
</style>
